function BrowseFilled({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.55 17.04L3.96 18.45L5.75 16.65L4.34 15.24L2.55 17.04ZM10 20.95H12V18H10V20.95ZM3 9H0V11H3V9ZM14 4.81V0H8V4.81C6.21 5.85 5 7.78 5 10C5 13.31 7.69 16 11 16C14.31 16 17 13.31 17 10C17 7.78 15.79 5.85 14 4.81ZM19 9V11H22V9H19ZM16.24 16.66L18.03 18.46L19.44 17.05L17.64 15.26L16.24 16.66Z" fill=${`"${col}"`}/>
  </svg>
  `;

  return baseXml;
}

export default BrowseFilled;
